import * as types from '../actions/ActionTypes';

const initialState = {
  programsList: [],
  programsDropdownList: [],
  programRecord: null,
  redirectToList: false,
  validation_error: null,
  showUpdateForm: false,
  showViewPage: false,
  formState: {}
};

const ProgramReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PROGRAMS_REQUEST:
      return { ...state, redirectToList: false, validation_error: null };
    case types.PROGRAMS_SUCCESS:
      return { ...state, programsList: action.programsList };
    case types.PROGRAMS_DROPDOWN_SUCCESS:
      return { ...state, programsDropdownList: action.programsDropdownList };
    case types.PROGRAMS_GET_SUCCESS:
      return {
        ...state,
        programRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.PROGRAMS_VALIDATION_ERROR: 
      return { ...state, validation_error: action.validation_error };
    case types.PROGRAMS_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        programRecord: null,
        formState: {},
        validation_error: null
      };
    case types.HIDE_PROGRAMS_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
          const new_validation_error = { ...state.validation_error };
          delete new_validation_error[action.feild_key];
          return { ...state, validation_error: new_validation_error };
      }
      return state;
    default:
      return state;
  }
};

export default ProgramReducer;
